import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { CrossReferencesModalComponent } from './cross-references-modal.component';
import { CrossReferencesModalParams } from './cross-references-modal-params';
import { Product } from '../../types/product';

@Injectable({
  providedIn: 'root',
})
export class CrossReferencesModalService {
  modalResult$ = new Subject<{
    initialProduct: Product;
    crossProduct: Product;
  }>();
  constructor(private modalService: NgbModal) {}

  openModal(modalParams: CrossReferencesModalParams) {
    const crossModal = this.modalService.open(CrossReferencesModalComponent, {
      size: modalParams.featureFlags.CONSUME_PRODUCT_DATA_MD_CAT_964488
        ? 'xxl'
        : 'xl',
      centered: true,
    });

    const componentInstance: CrossReferencesModalComponent =
      crossModal.componentInstance;
    componentInstance.modalParams$.next(modalParams);

    // TODO: check if this should be defined.
    // console.error(
    //   this.modalResult$,
    //   'modalResult$ required for modal component instance.'
    // );
    componentInstance.modalResult$.subscribe((modalResult) =>
      this.modalResult$.next(modalResult),
    );

    crossModal.result.then(
      // Does not need to return any values
      // because we are simply updating through the observable stream with modalResult$
      () => {},
      () => {},
    );

    return crossModal;
  }
}
